import { FC } from 'react';

import { useFormik } from 'formik';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { validationSchema } from '../form';

import css from './CreateDropForm.module.css';

import { telegramBotService } from 'v2/api/telegramBotService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { RewardsFormControl } from 'v2/components/form/rewardsFormControl/RewardsFormControl';
import { REWARD_STUB } from 'v2/constants';
import { TelegramBotDropForm } from 'v2/types/TelegramBotSettingsModel';
import { handleHttpError } from 'v2/utils';

interface CreateDropFormProps {
  onSuccess: VoidFunction;
}

export const CreateDropForm: FC<CreateDropFormProps> = ({ onSuccess }) => {
  const { trigger, isMutating } = useSWRMutation('createTelegramBotDrop', telegramBotService.createTelegramBotDrop, {
    onSuccess: () => {
      onSuccess();
      toast.success('The drop has been successfully created');
      formik.resetForm();
    },
    onError: handleHttpError,
  });

  const formik = useFormik<TelegramBotDropForm>({
    initialValues: {
      chanceToWin: 0,
      rewards: [REWARD_STUB],
    },
    validationSchema,
    onSubmit: (values) => {
      trigger(values);
    },
  });

  return (
    <Card className={css.createDropFormContainer}>
      <CardHeader title="Create Drop" icon={Plus} />

      <form className="form" onSubmit={formik.handleSubmit}>
        <TextField
          name="chanceToWin"
          value={formik.values.chanceToWin === 0 ? '' : formik.values.chanceToWin}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label="Chance to Win, %"
          error={!!formik.errors.chanceToWin}
          helperText={formik.errors.chanceToWin}
          required
          fullWidth
        />

        <RewardsFormControl formik={formik} withCount required />

        <Button type="submit" loading={isMutating} variant="contained" size="large">
          Create
        </Button>
      </form>
    </Card>
  );
};
